import axios from "axios";

export class CepService  {
    async getCep(url: string){
        return axios.get(url);
    }

}